
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { 
  TrendingUp, 
  BarChart3,
  Database,
  Target,
  Search,
  CheckCircle
} from 'lucide-react';

export function FeaturesGrid() {
  return (
    <>
      <div className="grid grid-cols-2 gap-4 text-sm">
        <div className="flex items-center gap-2">
          <TrendingUp className="h-4 w-4 text-green-600" />
          <span>Deep Learning Forecasts</span>
        </div>
        <div className="flex items-center gap-2">
          <BarChart3 className="h-4 w-4 text-blue-600" />
          <span>Peer Comparison Analysis</span>
        </div>
        <div className="flex items-center gap-2">
          <Database className="h-4 w-4 text-purple-600" />
          <span>Market Intelligence</span>
        </div>
        <div className="flex items-center gap-2">
          <Target className="h-4 w-4 text-orange-600" />
          <span>Phase-Specific Analysis</span>
        </div>
      </div>

      <div className="bg-white rounded-lg p-3 border">
        <h4 className="font-medium mb-2 flex items-center gap-2">
          <Search className="h-4 w-4" />
          Pre-Production Focus Areas
        </h4>
        <div className="flex flex-wrap gap-2">
          <Badge variant="secondary">Prospecting</Badge>
          <Badge variant="secondary">Exploration</Badge>
          <Badge variant="secondary">Development</Badge>
        </div>
      </div>

      <div className="text-xs text-gray-600 space-y-1">
        <div className="flex items-center gap-1">
          <CheckCircle className="h-3 w-3 text-green-500" />
          <span>LSTM & Transformer neural networks</span>
        </div>
        <div className="flex items-center gap-1">
          <CheckCircle className="h-3 w-3 text-green-500" />
          <span>Industry peer benchmarking</span>
        </div>
        <div className="flex items-center gap-1">
          <CheckCircle className="h-3 w-3 text-green-500" />
          <span>Real-time market intelligence</span>
        </div>
      </div>
    </>
  );
}
